import { AgGridVue } from 'ag-grid-vue'

export default {
  name: 'ReportItem',
  components: {
    AgGridVue
  },
  data () {
    return {
      // report grid
      onGridReport: null,
      reportRowData: [{}],
      reportColumnDefs: [
        {
          headerName: 'Início Apuração',
          field: 'inicio',
          minWidth: 150
          /*
          valueGetter: (param) => {
            if (param.data.inicio) {
              return moment(param.data.inicio).startOf('day').toDate().toLocaleDateString()
            }
          }
          */
        },
        {
          headerName: 'Término Apuração',
          field: 'termino',
          minWidth: 150
          /*
          valueGetter: (param) => {
            if (param.data.termino) {
              return moment(param.data.termino).startOf('day').toDate().toLocaleDateString()
            }
          }
          */
        },
        {
          headerName: 'Função',
          field: 'pdrFormularioItem.descricao',
          minWidth: 400
        }
      ],
      reportGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      // work grid
      onGridWork: null,
      workRowData: [{}],
      workColumnDefs: [
        {
          headerName: 'Coluna Obra A',
          // field: 'dataAcaoFormatada',
          minWidth: 150
        }
      ],
      workGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      }
    }
  },
  methods: {
    onGridReportReady (params) {
      this.onGridReport = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onGridWorkReady (params) {
      this.onGridWork = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    }
  },
  beforeMount () {
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reportItem/reportItem.js